import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {ReservationData} from "../../models/reservationData";


@Component({
    selector: 'exit-without-save-dialog',
    templateUrl: './exitWithoutSaveDialog.component.html',
    styleUrls: ['./exitWithoutSaveDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class ExitWithoutSaveDialogComponent {
    action: string;
    event: ReservationData;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    eventForm: FormGroup;


    /**
     *
     * @param matDialogRef
     * @param _data
     * @param translationLoader
     * @param translate
     * @param _matDialog
     */
    constructor(
        public matDialogRef: MatDialogRef<ExitWithoutSaveDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
    ) {
        this.translationLoader.loadTranslations(polish);
    }
}
